import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const AddPaymentDetails = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [brands, setBrands] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [formData, setFormData] = useState({
    name: "",
    amount: "",
    payment_method: "",
    payment_sent: "",
    description: "",
  });

  // Fetch Categories & Brands
  //   useEffect(() => {
  //     axios
  //       .post(`${API_BASE_URL}category_list.php`)
  //       .then((res) => setCategories(res.data.body || []))
  //       .catch((err) => console.error("Category fetch error:", err));
  //       axios
  //       .post(`${API_BASE_URL}supplier_list.php`)
  //       .then((res) => setSupplier(res.data.body || []))
  //       .catch((err) => console.error("Category fetch error:", err));
  //     axios
  //       .post(`${API_BASE_URL}brand_list.php`)
  //       .then((res) => setBrands(res.data.body || []))
  //       .catch((err) => console.error("Brand fetch error:", err));
  //   }, []);
  console.log(brands);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updatedFormData = { ...formData };

      console.log("Sending Data:", updatedFormData);

      const response = await axios.post(
        `${API_BASE_URL}payment_details_add.php`,
        updatedFormData,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.head.code === 200) {
        alert("payment details added successfully!");
        navigate("/paymentdetails");
      } else {
        alert(response.data.head.msg);
      }
    } catch (error) {
      console.error("Error adding payment details:", error);
      alert("Failed to add payment details");
    }
  };



  return (
    <>
      <Header />
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-body-wrapper">
          <div className="page-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="row">
                    <div className="col-sm-12 m-auto">
                      <div className="card">
                        <div className="card-body">
                          <div className="title-header option-title d-sm-flex d-block">
                            <h5>Add Payment Details</h5>
                            <div className="right-options">
                              <ul>
                                <li>
                                  <button
                                    className="btn btn-solid"
                                    onClick={() => window.history.back()}
                                  >
                                    Back
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <form
                            className="theme-form theme-form-2 mega-form"
                            onSubmit={handleSubmit}
                          >
                            <div className="row">


                              {/* Product Name */}
                              <div className="col-md-3 mb-4">
                                <label className="form-label-title">
                                  Name
                                </label>
                                <input
                                  required
                                  className="form-control"
                                  type="text"
                                  name="name"
                                  placeholder="Enter Name"
                                  onChange={handleChange}
                                />
                              </div>
                              <div className="col-md-3 mb-4">
                                <label className="form-label-title">
                                  Amount
                                </label>
                                <input
                                  required
                                  className="form-control"
                                  type="text"
                                  name="amount"
                                  placeholder="Enter Amount"
                                  onChange={handleChange}
                                />
                              </div>
                              {/* <div className="col-md-4 col-sm-6 mb-4">
                                <label className="form-label-title">
                                  Supplier Name
                                </label>
                                <select
                                  className="form-control"
                                  name="supplier_id"
                                  onChange={handleChange}
                                  required
                                >
                                  <option value="">Select Supplier</option>
                                  {supplier.map((supplier) => (
                                    <option
                                      key={supplier.id}
                                      value={supplier.id}
                                    >
                                      {supplier.supplier_name}
                                    </option>
                                  ))}
                                </select>
                              </div> */}

                              {/* Other Inputs (4 per row) */}

                              {/* <div className="col-md-3 mb-4">
  <label className="form-label-title">
    Payment Sent
  </label>
  <select
    required
    className="form-control"
    name="payment_sent"
    onChange={handleChange}
  >
    <option value="">Select</option>
    <option value="bank">Bank</option>
    <option value="gpay">GPay</option>
  </select>
</div> */}
                              <div className="col-md-3 mb-4">
                                <label className="form-label-title">
                                  Payment Sent
                                </label>
                                <input
                                  required
                                  className="form-control"
                                  type="text"
                                  name="payment_sent"
                                  placeholder="Enter Bank Name"
                                  onChange={handleChange}
                                />
                              </div>
                              <div className="col-md-3 mb-4">
                                <label className="form-label-title">
                                  Payment Method
                                </label>
                                <div className="d-flex">
                                  <div className="form-check me-3">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="payment_method"
                                      id="creditCard"
                                      value="credit"
                                      onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="creditCard">
                                      Credit
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="payment_method"
                                      id="paypal"
                                      value="debit"
                                      onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="paypal">
                                      Debit
                                    </label>
                                  </div>
                                </div>
                              </div>


                              {/* <div className="col-md-4 col-sm-6 mb-4">
                                <label className="form-label-title">
                                  Case Content
                                </label>
                                <div className="d-flex">
                                <input
                                  className="form-control"
                                  type="text"
                                  name="box_content"
                                  placeholder="Enter Pcs Count"
                                  onChange={handleChange}
                                />
                                <br />
                                <input
                                  className="form-control"
                                  type="text"
                                  name="unit"
                                  placeholder="Enter Unit"
                                  onChange={handleChange}
                                />
                                </div>
                              </div> */}
                              {/* <div className="col-md-6 col-sm-6 mb-4">
                                <label className="form-label-title">
                                  Stock
                                </label>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="stock"
                                  placeholder="Enter Stock"
                                  onChange={handleChange}
                                />
                              </div> */}








                            </div>
                            <div className="row">
                              <div className="mb-4 row align-items-center">
                                <label className="form-label-title col-sm-3 mb-0">Description</label>
                                <div className="col-sm-9">
                                  <textarea
                                    rows="3"
                                    className="form-control"
                                    name="description"

                                    onChange={handleChange}
                                    required
                                    placeholder="Enter Description"
                                  ></textarea>
                                </div>
                              </div>
                            </div>

                            {/* Buttons */}
                            <div className="card-footer border-0 pb-0 d-flex justify-content-end">
                              <button
                                className="btn btn-primary me-3"
                                type="submit"
                              >
                                Submit
                              </button>
                              <button
                                className="btn btn-outline"
                                onClick={() => window.history.back()}
                              >
                                Cancel
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPaymentDetails;
